module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAflBMVEUAAAD////j4+PR0dHb29vc3NzW1tbZ2dnZ2dnb29va2trY2Nja2trY2NjX19fY2NjX19fX19fZ2dnZ2dnY2NjY2NjY2NjZ2dnZ2dnY2NjY2NjZ2dnZ2dnY2NjY2NjZ2dnZ2dnZ2dnY2NjY2NjZ2dnY2NjZ2dnY2NjY2NjY2NgNXE27AAAAKXRSTlMAAwkLDhYlKDw/RVVZW2Zpc4aSlJeluLq80djc3t/j4+Tl7e7w9/f5/SZVMzEAAACNSURBVCjP5cxXEsIwDIRhEyCh19BLAqHp/hdkvIOE1hwBPe03f+IQPtcrF8Gfc74WWbnkPX4IRe/JSyh697F3uTbvzinuuquNPI9bRvaod/sa97mljTzFh0v7kbwBhha9sztQaCMPsCXTSJ5h3+xVcglcLJK3wNEieQ8cLJIr+d6PmySSn0kkSxLlD+Mb7HFJ5aOd5ukAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_yueban_left.png
// module id = iJGy
// module chunks = 2